import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'

export default function PodcastsSlider({ podcasts }) {
    const settings = {
        dots: false, // Dots are off by default
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true, // Arrows are on by default
        responsive: [
            {
                breakpoint: 1024, // For tablets and medium screens
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 768, // For mobile devices
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true, // Enable dots on mobile
                    arrows: false, // Disable arrows on mobile
                },
            },
        ],
    }

    return (
        <Slider {...settings}>
            {podcasts &&
                podcasts.map((podcast, idx) => (
                    <div key={idx} className="space-y-6 px-4">
                        <img
                            className="w-full h-auto block my-6" // Ensure the image scales properly
                            src={podcast?.thumbnail?.url}
                            alt={podcast.title}
                            title={podcast.title}
                        />
                        <a href={podcast.link} target="_blank" rel="noreferrer">
                            <h3 className="text-black text-xl md:text-2xl font-bold">
                                {podcast.title}
                            </h3>
                        </a>
                        <p className="text-gray-500 h-24 overflow-hidden text-ellipsis">
                            <div
                                className="line-clamp-4"
                                dangerouslySetInnerHTML={{
                                    __html: podcast?.description,
                                }}
                            />
                        </p>
                        <a
                            href={podcast.link}
                            target="_blank"
                            rel="noreferrer"
                            className="w-full sm:w-60 px-6 py-4 text-gray-600 border border-black rounded-full flex items-center space-x-2">
                            <svg
                                className="w-6 h-6 text-olh"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor">
                                <path
                                    fillRule="evenodd"
                                    d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            <span className="uppercase">Play Episode</span>
                        </a>
                    </div>
                ))}
        </Slider>
    )
}
